import React, { Component } from "react";
import EnviromentImage from "../../assets/enviroment.png";

export default class SecondaryContent extends Component {
  render() {
    return (
      <div className="relative bg-white pt-16 pb-32 overflow-hidden">
        <div className="relative">
          <div className="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
            <div className="px-4 max-w-md sm:max-w-3xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0">
              <div>
                <div className="mt-6">
                  <h2 className="text-3xl text-gray-900 font-extrabold tracking-tight sm:text-4xl">
                    ESG Reporting
                  </h2>
                  <p className="mt-4 text-base text-justify text-gray-500">
                    According to statistics from Seoul South Korea, with a total
                    of 8% metropolitan land area was use for community farming,
                    CO2 emission could be decreased by 11.67 million kg per year
                    (Offset carbon emissions of the whole cities). Carbon
                    emission has now being more important than ever when
                    awareness of being created by corporates such as Apple,
                    Google etc. Alibaba has also launched an initiative which
                    allows users to donate small amount residing in their
                    AliPay's account for planting trees.
                  </p>
                  <p className="mt-4 text-base text-justify text-gray-500">
                    Ubi App believes our approach of connecting corporates'
                    sponsorship to B40 group for community farming is proven,
                    providing impact and scalable (light-weight).
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-12 sm:mt-16 lg:mt-0">
              <div className="flex items-center pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 lg:m-0 lg:relative lg:h-full">
                <img
                  className="w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:left-0 lg:h-full lg:max-h-96 lg:w-auto lg:max-w-none"
                  src={EnviromentImage}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
